import {
  ButtonElementModel,
  DevelopScriptServicePack,
  InputPartsBaseModel,
  LinkElementModel,
  PanelModel,
  PanelType,
  WeekTimeTablePanelElementModel,
  WeekTimeTableViewScript,
} from '@ktvs8/gocoo-engine-front-end';

export class ProgramWeekTimeTable implements WeekTimeTableViewScript {
  scriptName: string = 'program-week-time-table';

  /**
   * 初期処理
   * @param panelModels
   * @param service
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * クローズ処理
   * @param panelModels
   * @param service
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * タイムテーブルが最新化されたタイミングで実行される処理
   * @param WeekTimeTablePanelModel
   */
  fetchedSchedule(WeekTimeTablePanelModel: WeekTimeTablePanelElementModel): void {
    WeekTimeTablePanelModel.oneWeekProgramList.forEach((oneWeekProgram) => {
      oneWeekProgram.hourProgramElementModel.forEach((hour) => {
        const tt = hour.getHourForLabel();
      });
    });
  }

  /**
   * ボタン押下処理
   * @param panelModels
   * @param clickedButtonElement
   * @param service
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * リンクを押下した処理
   * @param panelModels
   * @param clickedLinkElement
   * @param service
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * input-partsの値が変更された際の処理
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {}
}
